<!--suppress ALL -->
<template>
  <g-field :label="label" :type="type" :message="message">
    <g-field is-grouped>
      <g-select @change="onSelected" is-fullwidth :value="asrama || ''"
                :placeholder="asramas.length === 0 ? $t('text.no_content_loaded') :
                `${placeholder}`" class="control is-expanded">
        <option v-for="asrama in asramas"
                :value="asrama.nama" :key="asrama.kode">
          {{ asrama.nama }}
        </option>
      </g-select>
      <div v-if="isLoading" class="control">
        <g-button type="light">
          <span class="icon">
            <i class="fas fa-spinner fa-spin"></i>
          </span>
        </g-button>
      </div>
    </g-field>
  </g-field>
</template>

<script lang="ts">
import {Component, Vue, Prop} from 'annotation';
import {cloneDeep} from 'lodash';
import Asrama from "../../../entity/Asrama";
import Authentication from '../../../Authentication';
import Store from "../../../util/Store";

@Component
export default class FilteredAsramaSantriSelect extends Vue {

  @Prop({default: "", type: String})
  public asrama: string;

  @Prop({default: "Asrama", type: String})
  public label: string;

  @Prop({default: "Pilih asrama", type: String})
  public placeholder: string;

  @Prop({type: String, default: null})
  public type: any;

  @Prop({type: String, default: null})
  public message: any;

  public isLoading: boolean = false;

  public get asramas() {
    let asramas: Array<Asrama> = Store.getVmProperty('asrama.data', []);
    // Tambahkan opsi "SEMUA" di awal list
    const semuaAsrama = new Asrama();
    semuaAsrama.kode = 'ALL';
    semuaAsrama.nama = 'SEMUA';
    return [semuaAsrama, ...asramas];
  }

  public created() {
    Store.dispatchAsramaByWilayah(true, Authentication.getUser().roles[0]);
  }

  public onSelected(nama: string) {
    const asrama: Asrama = this.asramas.find((item: Asrama) => item.nama === nama) ||
      new Asrama();

    this.$emit('asrama-selected', cloneDeep(asrama));
  }

}
</script>
